import { useDispatch } from "react-redux";
import { useEffect, useState } from "react";
import { ListaSolicitudes } from "./lista/ListaSolicitudes";
import { ModalCrearSolicitud } from "./crear/ModalCrearSolicitud";
import { ModalChat } from "./chat/ModalChat";
import { getSolicitudes } from "../../context/actions/solicitudesActions";
import "./utils/atencion.css";

export const Atencion = () => {
  const dispatch = useDispatch();
  const [modalCrearVisible, setModalCrearVisible] = useState(false);
  const [modalChatVisible, setModalChatVisible] = useState(false);
  const [solicitudSeleccionada, setSolicitudSeleccionada] = useState(null);

  useEffect(() => {
    dispatch(getSolicitudes());
  }, [dispatch]);

  const handleCrearSolicitud = () => {
    setModalCrearVisible(true);
  };

  const handleModalCrearClose = () => {
    setModalCrearVisible(false);
  };

  const handleOpenChat = (solicitud) => {
    setSolicitudSeleccionada(solicitud);
    setModalChatVisible(true);
  };

  const handleModalChatClose = () => {
    setModalChatVisible(false);
    setSolicitudSeleccionada(null);
  };

  return (
    <div className="atencion-view">
      <ListaSolicitudes 
        onCrearSolicitud={handleCrearSolicitud}
        onOpenChat={handleOpenChat}
      />
      
      <ModalCrearSolicitud 
        visible={modalCrearVisible} 
        onClose={handleModalCrearClose} 
      />
      
      <ModalChat
        visible={modalChatVisible}
        onClose={handleModalChatClose}
        solicitud={solicitudSeleccionada}
      />
    </div>
  );
};